import { wfetch } from '@wf-mfe/api'
import { NOTIFICATIONS_LIMIT } from '../utils/constants'

export function getNotifications(limit = NOTIFICATIONS_LIMIT, includeAll = false) {
  return wfetch(`/internal/notification/myNotifications?limit=${limit}&includeAll=${includeAll}`)
}

export function markNotificationsRead(IDs) {
  return wfetch(`/internal/notification/markAsSeen?ID=${IDs.join(',')}`, {
    method: 'POST',
  })
}
